import Slider from 'react-slick';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { useRef } from 'react';
import type SliderBase from 'react-slick';
import { Caregiver, Service } from '@/types';
import CaregiverReviewCard from './CaregiverReviewCard';

// Types & Interfaces
type SliderProps = React.ComponentProps<typeof Slider>;
type CarouselProps = {
  cards: (Caregiver | Service)[];
  sliderSettingsProps?: Partial<SliderProps>;
  setRef?: (ref: Slider | null) => void;
};

const CaregiverReviewsCarousel = ({ cards, sliderSettingsProps }: CarouselProps) => {
  const theme = useTheme();
  const carouselRef = useRef<SliderBase | null>(null);
  const show3Slides = useMediaQuery(theme.breakpoints.up(1056));
  const show2Slides = useMediaQuery(theme.breakpoints.up(683));

  const getSlidesToShow = () => {
    if (show3Slides) return 3;
    if (show2Slides) return 2;
    return 1;
  };

  //  @see https://react-slick.neostack.com/docs/api
  const sliderDefaultSettings: SliderProps = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: getSlidesToShow(),
    slidesToScroll: 1,
    touchThreshold: 150,
    arrows: false,
    adaptiveHeight: true,
    variableWidth: true,
  };

  return (
    <Box data-testid="caregiver-reviews-carousel">
      <Slider {...sliderDefaultSettings} {...sliderSettingsProps} ref={carouselRef}>
        {cards.map((card) => (
          <Box key={`caregiver-review-card-${card.key}`} mr={3}>
            <CaregiverReviewCard card={card} />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default CaregiverReviewsCarousel;
